import { KeyCreatorFunction } from './types';

export const singleSelectKeyCreator: KeyCreatorFunction = ({ value }) => {
  return value ?? '';
};
